/** Airline GDS name-field limit; see docs/features/character-length-validation-buffers.md */
export const PASSENGER_NAME_CHAR_LIMIT = 59;
export const STANDARD_NAME_BUFFER = 12;
export const INFANT_COMBINED_NAME_BUFFER = 20;

const trimName = name => (name ? name.trim().replace(/\s+/g, "") : "");

export function validateName(name) {
  if (!name) {
    return false;
  }
  if (/\d/.test(name)) {
    return false;
  }
  if (name.length <= 1) {
    return false;
  }
  if (/[^a-zA-Z\s-]/.test(name)) {
    return false;
  }
  return true;
}

export function validateMiddleName(name) {
  if (!name) {
    return true;
  }
  if (/\d/.test(name)) {
    return false;
  }
  if (/[^a-zA-Z\s-]/.test(name)) {
    return false;
  }
  return true;
}

export function passengerFullNameLength(passenger) {
  const fullName = [
    passenger.title,
    trimName(passenger.firstName),
    trimName(passenger.middleName),
    trimName(passenger.lastName)
  ]
    .filter(Boolean)
    .join("");

  return fullName.length;
}

export function validateMaxCharLengthOnPassenger(passenger) {
  const maxCharacterLength =
    PASSENGER_NAME_CHAR_LIMIT - STANDARD_NAME_BUFFER;
  return passengerFullNameLength(passenger) <= maxCharacterLength;
}

export function validateMaxLengthForInfantBookings(infant, adult) {
  const adultCharacters = [
    adult.title,
    trimName(adult.firstName),
    trimName(adult.middleName),
    trimName(adult.lastName)
  ]
    .filter(Boolean)
    .join("");

  const infantCharacters = [
    infant.title,
    trimName(infant.firstName),
    trimName(infant.middleName),
    trimName(infant.lastName)
  ]
    .filter(Boolean)
    .join("");

  const maxCharacterLengthInfant =
    PASSENGER_NAME_CHAR_LIMIT - INFANT_COMBINED_NAME_BUFFER;
  const totalCharacters = `${infantCharacters}${adultCharacters}`.length;

  return totalCharacters <= maxCharacterLengthInfant;
}
